import * as Counter from './counter';

export const reducers = {
    counter: Counter.reducer,
};